import {API_BASE_URL, PATH_INVITES, PATH_TRIGGER} from '../constants/constants';
import {getFingerPrint, request} from "./APIService";

export function getInvite(id) {
    return request({
        url: API_BASE_URL + PATH_INVITES + '/' + id,
        method: 'GET'
    }, []);
}

export function triggerInviteAction(inviteId, actionId, coords) {
    return getFingerPrint().then(response => {
        const fingerPrint = response;
        if (coords) {
            fingerPrint['latitude'] = coords.latitude;
            fingerPrint['longitude'] = coords.longitude;
        }
        return request({
            url: API_BASE_URL + PATH_INVITES + '/' + inviteId + '/' + actionId + PATH_TRIGGER,
            method: 'POST',
            body: JSON.stringify(fingerPrint)
        }, [])
    });
}


// WEBPACK FOOTER //
// ./src/app/services/InvitesService.js